// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"95":"48cec156","215":"d37dff5d"}[chunkId] + ".js";
};